import moment from "moment";
import { date } from "@/types/common";

const API_FORMAT = "MM/DD/YYYY HH:mm:ss",
  DATE_DISPLAY_FORMAT = "DD/MM/YYYY",
  DATE_TIME_DISPLAY_FORMAT = "DD/MM/YYYY HH:mm",
  TIME_DISPLAY_FORMAT = "HH:mm";

const format = [
  "DD/MM/YYYY",
  "YYYY-MM-DD hh:mm:ss",
  "YYYY-MM-DD HH:mm:ss",
  "MM/DD/YYYY hh:mm:ss",
  API_FORMAT,
  DATE_DISPLAY_FORMAT,
  "hh:mm:ss",
];
const weekDayFormat = "ddd";
export const getMomentDate = (date: date): moment.Moment | undefined =>
  date ? moment(date, format) : undefined;

export const formatAPIDate = (date: date): string | undefined =>
  getMomentDate(date)?.format(API_FORMAT);

export const displayDate = (
  date: date,
  format: string = ""
): string | undefined => {
  return date
    ? getMomentDate(date)?.format(format ? format : DATE_DISPLAY_FORMAT)
    : "";
};

export const displayDay = (date: date): string | undefined => {
  const momentDate = getMomentDate(date);
  return momentDate?.format("ddd");
};

export const displayDateTime = (date: date): string | undefined =>
  date ? getMomentDate(date)?.format(DATE_TIME_DISPLAY_FORMAT) : "";

export const displayTime = (date: date): string | undefined =>
  date ? getMomentDate(date)?.format(TIME_DISPLAY_FORMAT) : "";

export const convertToDate = (date: date): Date => {
  const momentDate = getMomentDate(date);
  return momentDate ? momentDate.toDate() : new Date();
};

export const getHours = (date: date): string | undefined => {
  const momentDate = getMomentDate(date);
  return momentDate?.format("HH");
};

export const getMinutes = (date: date): string | undefined => {
  const momentDate = getMomentDate(date);
  return momentDate?.format("mm");
};

export const combineDateHrMin = (
  date: date,
  hourDate: date,
  minuteDate: date
) => {
  const hours = getHours(hourDate);
  const minutes = getMinutes(minuteDate);
  return formatAPIDate(
    moment(
      displayDate(date) + " " + hours + ":" + minutes,
      "DD/MM/YYYY HH:mm"
    ).toDate()
  );
};

export const getDurationInMinutes = (start: date, end: date): number => {
  const durationInMinutes = getMomentDate(end)?.diff(
    getMomentDate(start),
    "minutes"
  );
  return durationInMinutes ? durationInMinutes : 0;
};

export const getDurationInHours = (start: date, end: date): number => {
  const durationInMinutes = getDurationInMinutes(start, end);
  return durationInMinutes / 60;
};

export const getDurationInDays = (start: date, end: date) => {
  const hours = getDurationInHours(
    getMomentDate(start)?.clone().startOf("day").toDate(),
    getMomentDate(end)?.clone().endOf("day").toDate()
  );
  if (hours) return Math.ceil(hours) / 24;
};

export const getCurrentDate = (): date => {
  const date = new Date();

  return formatAPIDate(date);
};
